import {request, getToken} from "./request";

function getSysReq(method, bizContent={}) {
    return request({
        url: '/toodo/tdk/sys?token=' + getToken(),
        data: {
            method,
            bizContent
        }
    })
}

//获取广告信息
function getAppAds(bizContent={}) {
    return getSysReq('/getAppAds', bizContent)
}

// 广告展示
function showAppAds(bizContent={}) {
    console.log("showAppAds==============================================")
    return getSysReq('/showAppAds', bizContent)
}

// 广告点击
function clickAppAds(bizContent={}) {
    return getSysReq('/clickAppAds', bizContent)
}

export const apiSys = {
    getAppAds,
    showAppAds,
    clickAppAds,

}